import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=863d0bde&scoped=true&lang=pug&"
import script from "./MenuEdit.vue?vue&type=script&lang=ts&"
export * from "./MenuEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=863d0bde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863d0bde",
  null
  
)

export default component.exports